import React from 'react';
import PropTypes from 'prop-types';

// import select
import Select from "react-select"

const Selecter = ({ id, name, placeholder, multiple, loading, selected, options, onSelected, valueAttribut, labelAttribut, selecterClasses, selecterClassesPrefix }) => {
  
  const formatItemsWithValuesAndLabels = (items) => {

    if (!Array.isArray(items)) {
      return [];
    }
  
    return items.map((item) => {
      if (typeof item === "object" && item?.value && item?.label) {
        return item;
      } else if (typeof item === "string" || typeof item === "number") {
        return {
          value: item.toString(),
          label: item.toString()
        };
      } else {
        return null;
      }
    }).filter(Boolean);
  
  };
  
  
  return (
    <Select
      defaultValue={formatItemsWithValuesAndLabels(selected)}
      onChange={(selected) => onSelected(selected, name)}
      options={formatItemsWithValuesAndLabels(options)}
      loadingMessage={() => 'Chargement...'}
      noOptionsMessage={() => 'Aucune option'}
      className={selecterClasses}
      classNamePrefix={selecterClassesPrefix}
      isDisabled={false}
      isLoading={loading}
      isClearable={true}
      isSearchable={true}
      isMulti={multiple}
      placeholder={placeholder}
      name={name}
      id={id}
    />
  );
  

}
Selecter.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    multiple: PropTypes.bool,
    loading: PropTypes.bool,
    selecterClasses: PropTypes.string,
    selecterClassesPrefix: PropTypes.string,
    options: PropTypes.array.isRequired,
    selected: PropTypes.array.isRequired,
    onSelected: PropTypes.func.isRequired
}
Selecter.defaultProps = {
    id: "",
    name: "",
    placeholder: "Sélectionner...",
    multiple: false,
    loading: false,
    selected: [],
    valueAttribut: "id",
    labelAttribut: "name",
    selecterClasses: "default-selects",
    selecterClassesPrefix: "default-selects-prefix"
}
export default Selecter;
